import { useEffect } from 'react';
import { useSurfaceContext, type SurfaceChatContext } from '../contexts/SurfaceContext';

/**
 * Publish (and cleanup) explicit surface context for the Chat Panel.
 * Pass `null` to defer to route fallback until ready.
 */
export function usePublishSurfaceChatContext(context: SurfaceChatContext | null): void {
  const { setSurfaceContext } = useSurfaceContext();

  useEffect(() => {
    if (!context) {
      setSurfaceContext(null);
      return;
    }
    setSurfaceContext(context);
    return () => setSurfaceContext(null);
  }, [context, setSurfaceContext]);
}
